import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const createToteGroup = {
  name: "createToteGroup" as const,
  input: z.object({ name: z.string(), locationId: locationIdFormat.schema }),
  output: RedoFulfillmentToteGroupSchema,
};
